
import React from 'react';

type AuthSidePanelProps = {
  activeTab: 'login' | 'signup';
};

export default function AuthSidePanel({ activeTab }: AuthSidePanelProps) {
  // Defensive programming: ensure activeTab has an expected value
  const isLogin = activeTab === 'login';

  return (
    <div className="hidden lg:flex lg:w-[480px] xl:w-[540px] relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b255a13a98992aa72f7030d2bd8c65f3.jpg"
          alt="Greenify Education"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/80 via-emerald-800/70 to-slate-900/90"></div>
      </div>

      <div className="relative z-10 flex flex-col justify-between p-12 w-full">
        <div />

        <div className="space-y-8">
          <div>
            <h2 className="text-3xl font-bold text-white leading-tight mb-4">
              {isLogin ? 'Welcome Back to Greenify' : 'Join the Greenify Team'}
            </h2>
            <p className="text-emerald-100 text-sm leading-relaxed">
              {isLogin
                ? 'Access your admin dashboard to manage bookings, track student progress, and oversee consultation schedules.'
                : 'Create your admin account to start managing student consultations and educational services.'}
            </p>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <div className="w-10 h-10 bg-emerald-400/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-calendar-check-line text-emerald-300 text-lg"></i>
              </div>
              <div>
                <p className="text-white text-sm font-medium">Manage Bookings</p>
                <p className="text-emerald-200 text-xs">Track and organize all consultations</p>
              </div>
            </div>

            <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <div className="w-10 h-10 bg-emerald-400/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-bar-chart-box-line text-emerald-300 text-lg"></i>
              </div>
              <div>
                <p className="text-white text-sm font-medium">Analytics Dashboard</p>
                <p className="text-emerald-200 text-xs">Real-time insights and statistics</p>
              </div>
            </div>

            <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <div className="w-10 h-10 bg-emerald-400/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-emerald-300 text-lg"></i>
              </div>
              <div>
                <p className="text-white text-sm font-medium">Availability Control</p>
                <p className="text-emerald-200 text-xs">Set your schedule with ease</p>
              </div>
            </div>
          </div>
        </div>

        {/* Use HTML entity for the copyright symbol to avoid parsing issues */}
        <p className="text-emerald-300/60 text-xs mt-12">
          &copy; 2025 Greenify Educational Consult
        </p>
      </div>
    </div>
  );
}
